import { SetupChatBot } from '@/config/types';
import { apiConfig } from '@/services/api-config';

export default async function () {
  const userLogged = sessionStorage.getItem('userLogged');

  let stKey = '';
  let companyAppId = 0;

  if (userLogged) {
    stKey = JSON.parse(userLogged).company.stKey;
    companyAppId = JSON.parse(userLogged).company.companyApplication.idCompanyApplication;
  }

  return apiConfig
    .get<SetupChatBot>(`api/setup/get-chat-bot?companyApplicationId=${companyAppId}&tokenKey=${stKey}`)
    .then((response) => response.data)
    .catch(() => null);
}
